module.exports = __webpack_public_path__ + "static/img/icon_zanwusx@2x.5e96a471.png";